var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEBUG_STATES, spenttimeDebug as debug } from '../debug';
import { getDeviceType } from '../../utils/getDeviceType';
import { DEFAULT_CONFIG, DEFAULT_ITEMS_CONFIG } from '../../constants';
import { getContainerElement, isUserActivityTimeCorrect, isPercent, isDelayCorrect, isNumberOfItemsInHitCorrect, isSelectorValid, isNotEmptyString, } from './checks';
/**
 * Сhecks the incoming parameters of ITEM config and if everything is fine, returns the verified ITEM configuration or null
 * @param incomingItemsConfig Object with incoming item configuration
 * @param deviceType Device type
 * @returns Object of verified item configuration
 */
var getVerifiedItemsConfig = function (incomingItemsConfig, deviceType) {
    if (!incomingItemsConfig ||
        !isSelectorValid(incomingItemsConfig.selector) ||
        !isNotEmptyString(incomingItemsConfig.attributeWithDopId)) {
        debug({
            type: 'warn',
            message: '[ITEMS CONF] Warning: Required parameters for measuring the spent time on items ' +
                'are missing or incorrect. The items measurement will not be performed.',
        });
        return null;
    }
    var attributeWithDopDetails = incomingItemsConfig.attributeWithDopDetails
        ? incomingItemsConfig.attributeWithDopDetails
        : DEFAULT_ITEMS_CONFIG.attributeWithDopDetails;
    var numberOfItemsInHit = isNumberOfItemsInHitCorrect(incomingItemsConfig.numberOfItemsInHit)
        ? incomingItemsConfig.numberOfItemsInHit
        : DEFAULT_ITEMS_CONFIG.numberOfItemsInHit;
    var deviceItemsConfig = __assign(__assign({}, DEFAULT_ITEMS_CONFIG[deviceType]), incomingItemsConfig[deviceType]);
    if (!isDelayCorrect(deviceItemsConfig.measurementStartDelay)) {
        debug({
            type: 'warn',
            message: '[ITEMS CONF] Warning: items.measurementStartDelay is not correct. The items measurement will not be performed.',
        });
        return null;
    }
    if (!isPercent(deviceItemsConfig.intersectionThreshold)) {
        debug({
            type: 'warn',
            message: '[ITEMS CONF] Warning: items.intersectionThreshold is not correct. The items measurement will not be performed.',
        });
        return null;
    }
    if (!isPercent(deviceItemsConfig.targetAreaHeight) || !isPercent(deviceItemsConfig.targetAreaWidth)) {
        debug({
            type: 'warn',
            message: '[ITEMS CONF] Warning: target area size for items is not correct. The items measurement will not be performed.',
        });
        return null;
    }
    return {
        selector: incomingItemsConfig.selector,
        attributeWithDopId: incomingItemsConfig.attributeWithDopId,
        attributeWithDopDetails: attributeWithDopDetails,
        numberOfItemsInHit: numberOfItemsInHit,
        measurementStartDelay: deviceItemsConfig.measurementStartDelay,
        intersectionThreshold: deviceItemsConfig.intersectionThreshold,
        targetAreaHeight: deviceItemsConfig.targetAreaHeight,
        targetAreaWidth: deviceItemsConfig.targetAreaWidth,
    };
};
/**
 * Сhecks the incoming parameters of config and if everything is fine, returns the verified configuration or null
 * @param incomingElement HTMLElement or element Id or selector
 * @param incomingConfig  Object with incoming configuration
 * @returns Object of verified configuration
 */
export var getVerifiedConfig = function (incomingElement, incomingConfig) {
    var _a, _b;
    if (incomingConfig === void 0) { incomingConfig = {}; }
    // Сhecking that the element exists
    var container = getContainerElement(incomingElement);
    if (!container) {
        debug({
            type: 'error',
            message: "[CONF] Error: html element by \"".concat(incomingElement, "\" not found."),
            state: DEBUG_STATES.ERROR,
        });
        return null;
    }
    // Сhecking the time configuration for different devices
    var deviceType = getDeviceType();
    var deviceConfig = __assign(__assign({}, DEFAULT_CONFIG[deviceType]), incomingConfig[deviceType]);
    deviceConfig.measuring = deviceConfig.measuring && isUserActivityTimeCorrect(deviceConfig);
    if (!deviceConfig.measuring) {
        debug(__assign({ type: 'warn', message: "[CONF] Warning: The configuration for ".concat(deviceType, " devices is not correct or measurement is disabled for this type of device.") }, deviceConfig));
        return null;
    }
    // Checking the intersection threshold for container element
    var intersectionThreshold = ((_a = incomingConfig.container) === null || _a === void 0 ? void 0 : _a.intersectionThreshold) || ((_b = incomingConfig.container) === null || _b === void 0 ? void 0 : _b.intersectionThreshold) === 0
        ? incomingConfig.container.intersectionThreshold
        : DEFAULT_CONFIG.container.intersectionThreshold;
    if (!isPercent(intersectionThreshold)) {
        debug({
            type: 'error',
            message: "[CONF] Error: container.intersectionThreshold is not correct.",
            state: DEBUG_STATES.ERROR,
        });
        return null;
    }
    // final configuration (without items configuration)
    var config = {
        fallAsleepTime: deviceConfig.fallAsleepTime,
        forcedDepartureTime: deviceConfig.forcedDepartureTime,
        device: deviceType,
        container: {
            intersectionThreshold: intersectionThreshold,
            element: container,
        },
    };
    // Cheking items configuration
    var itemsConfig = getVerifiedItemsConfig(incomingConfig.items, deviceType);
    if (itemsConfig) {
        config.items = itemsConfig;
    }
    debug(__assign({ message: 'Configuration:' }, config));
    return config;
};
